import { useEffect } from 'react';
import { useBackClose } from '../lib/backClose';
import { cn } from '../lib/utils';

/** Bottom sheet. Tapping the scrim or pressing Escape closes it. */
export default function Sheet({ open, onClose, children, className, dismissible = true, label }) {
  useBackClose(open, onClose, dismissible);
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape' && dismissible) onClose?.();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, dismissible, onClose]);

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-40 flex items-end justify-center" role="dialog" aria-modal="true" aria-label={label}>
      <button type="button" aria-label="Close" className="absolute inset-0 bg-ink/45" onClick={dismissible ? onClose : undefined} />
      <div
        className={cn(
          'sheet-in safe-b relative max-h-[92vh] w-full max-w-lg overflow-y-auto rounded-t-[1.5rem] bg-surface shadow-2xl',
          className
        )}
        // a tapped button must not keep focus: a scanner's Enter would press it again
        onClick={(e) => {
          if (e.detail > 0 && document.activeElement?.tagName === 'BUTTON') document.activeElement.blur();
        }}
      >
        <div className="mx-auto mt-2 h-1 w-10 rounded-full bg-line" />
        {children}
      </div>
    </div>
  );
}
